// client/src/pages/MoonbeamView.js
//
// Route wrapper for the public Moonbeam view. Parses URL query params and
// passes them down to MoonbeamPreview. The actual rendering, analytics
// tracking, and reactions live in MoonbeamPreview.
//
// NAVBAR REVISION:
//   - MoonbeamPreview now renders the standard site <Navbar /> itself and
//     owns its full-page layout (navbar + sub-bar + card area). This wrapper
//     previously added `min-h-screen py-8 px-4`, which pushed the content
//     down and added side padding that fought the flush, full-width navbar.
//     The wrapper is now a bare passthrough so the navbar sits flush at the
//     top of the page.
//
// CHANGES IN PREVIOUS REVISION (Shareable Links & Reactions build):
//   - Reads ?l= (shareable link token) in addition to ?r= (per-recipient
//     view token). Both pass down to MoonbeamPreview. If both are somehow
//     present, the recipient token wins (more specific attribution).

import { useParams, useSearchParams } from 'react-router-dom';
import MoonbeamPreview from '../components/moonbeams/MoonbeamPreview.js';

export default function MoonbeamView() {
  const { uuid } = useParams();
  const [searchParams] = useSearchParams();

  // ?r= recipient token (email recipient)
  // ?l= shareable link token
  const recipientToken = searchParams.get('r');
  const linkToken = searchParams.get('l');

  return (
    <MoonbeamPreview
      uuid={uuid}
      recipientToken={recipientToken}
      linkToken={linkToken}
    />
  );
}